import type { Components } from '@mui/material/styles';

export default function MUIAccordionDetails(): Components['MuiAccordionDetails'] {
  return {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  };
}
